import { ChangeEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@mui/material';

import { RequiredLabel } from 'main/components/_common/RequiredLabel';
import { selectSharedVideoDescription } from 'main/store/videos/selectors';
import { changeSharedVideoFormDescription } from 'main/store/videos/actions';

export const DescriptionTextField = () => {
    const dispatch = useDispatch();
    const value = useSelector(selectSharedVideoDescription);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeSharedVideoFormDescription(event.target.value));
    }, [dispatch]);

    return (
        <TextField
            multiline
            fullWidth
            rows={5}
            label={<RequiredLabel label="説明" />}
            value={value}
            onChange={handleChange}
        />
    )
}
